/**
 * Implements the drilldown link behavior of RVC DataTables
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import {
  decodeData,
  routeFromHash,
  slugify,
  generalizeRouteName,
} from "../../utils";

import Modal from "../../views/drilldown";
// import Modal from "../../views/generic/modal/base";
import DatatableLinkModel from "../../models/datatable-link";
import MenuItemCollection from "../../collections/menu-items";

const channel = Radio.channel("global");

class DataTableLink extends Marionette.Behavior {
  ui() {
    return {
      link: "a.drilldown",
    };
  }

  events() {
    return {
      // debounces clicks on link
      "click @ui.link": _.debounce(this._handleClick, 400, true),
    };
  }

  initialize() {
    this.listenTo(channel, "launch-link", this._launchLink);
  }

  _handleClick(e) {
    e.preventDefault();

    // here you can override the default modal layout ("tabbed" | "stacked"),
    // but ideally that property is fed via the API and used here.

    // extract link data
    const linkData = $(e.currentTarget).data();
    const { params, type, url, returnRoute, returnRouteRefresh } = linkData;

    // deserialize params
    const data = JSON.parse(decodeData(params));
    const endpoint = decodeData(url);

    // create link model
    const model = new DatatableLinkModel({
      type,
      endpoint,
      data,
      returnRoute,
      returnRouteRefresh: !!returnRouteRefresh || false,
    });

    // console.log("_handleClick", model.toJSON());

    this._launchLink(model);
  }

  _launchLink(model) {
    if ("main" === model.getType()) {
      // render to main screen

      // does this endpoint match a route?
      let route = channel.request("router:matchPath", model.getEndpoint());
      if (route) {
        // navigate to route
        channel.request("router:navigate", route.name, model.getData());
      } else {
        // define a new route
        route = {
          category: "home",
          description: "Label",
          name: routeFromHash(`#${model.getEndpoint()}`),
          path: model.getEndpoint(),
          url: model.getEndpoint(),
          data: model.getData(),
        };

        // add new route into menu collection
        const coll = new MenuItemCollection(route);

        // insert menu collection into router
        channel.request("router:add", coll);

        // navigate to new route
        channel.request("router:navigate", route.name);
      }
    } else if ("modal" === model.getType()) {
      // generalize route name from endpoint
      const route = generalizeRouteName(slugify(model.getEndpoint()));

      // trigger an event to render a custom drilldown modal
      // event must be registered on one of the listeners loaded by Layout.
      // console.groupCollapsed(route);
      // console.log(model.toJSON());
      // console.groupEnd(route);
      channel.trigger(route, model);
    } else {
      // render to generic drilldown modal

      // instantiate modal view
      new Modal({
        returnRoute: model.getReturnRoute(),
        returnRouteRefresh: model.getReturnRouteRefresh(),
        model,
      });
    }
  }
}

export { DataTableLink as default };
